import { useState } from "react";
import MainLayout from "../../../components/layout/layout";
import { BodyBlock } from "../sign-in";
import { LabelText, LargeHeadline, LittleText } from "../../../components/typography";
import styled from "styled-components";
import Stepper from "../../../components/ui/stepper";
import { Outlet, useLocation } from "react-router-dom";
import { onboardingSteps } from "./step.config";
import { COLORS } from "../../../assets/utils/enums/colors";
import { OnboardingPlanEnum, StructureCRMEnum } from "../../../assets/utils/data/onboarding";

export default function OnboardingSettings() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loaderState, setLoaderState] = useState<boolean>(false);
    const location = useLocation();
    const activeStepId =
        onboardingSteps.find(step =>
            location.pathname.includes(step.path)
        )?.id ?? 1;
    const [name, setName] = useState<string>("");
    const [structure, setStructure] = useState<StructureCRMEnum>(StructureCRMEnum.EMPTY);
    const [plan, setPlan] = useState<OnboardingPlanEnum>(OnboardingPlanEnum.PRO);

    return (
        <MainLayout
            className="d-flex flex-column align-items-center"
            loaderState={loaderState}
        >
            <OnboardingBodyBlock>
                <LargeHeadline>Налаштування робочого простору</LargeHeadline>
                <Stepper steps={onboardingSteps} activeStepId={activeStepId} />
            </OnboardingBodyBlock>
            <Outlet context={{ name, setName, structure, setStructure, plan, setPlan }} />
        </MainLayout>

    )
}

export const OnboardingBodyBlock = styled(BodyBlock)`
width: 70%;
flex-grow: 0;
${LabelText} {
    color: ${COLORS.secondary1};
}

${LittleText} {
    color: ${COLORS["bg-text-color"]};

    &.accent-color {
    color: ${COLORS.blue};

    }
}
`
